import React from 'react';
import {
  useDronesPageViewModel,
  type DronesPageViewModel,
} from '@src/features/drone/hooks/useDronesPageViewModel';

const DronesPageViewModelContext = React.createContext<DronesPageViewModel | null>(null);

export const DronesPageViewModelProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const value = useDronesPageViewModel();
  return (
    <DronesPageViewModelContext.Provider value={value}>
      {children}
    </DronesPageViewModelContext.Provider>
  );
};

export function useDronesPage(): DronesPageViewModel {
  const ctx = React.useContext(DronesPageViewModelContext);
  if (!ctx) {
    throw new Error('useDronesPage must be used within DronesPageViewModelProvider');
  }
  return ctx;
}
